import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function AdminSettings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)); }, []);

  const save = async () => {
    try { await api.patch("/admin/settings", s); toast.success("Impostazioni salvate"); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  if (!s) return <div>Caricamento…</div>;
  const set = (k, v) => setS({ ...s, [k]: v });

  return (
    <div className="max-w-2xl">
      <div className="eyebrow">Configurazione</div>
      <h1 className="text-4xl mt-1">Impostazioni</h1>

      <section className="card-elevated p-5 mt-6 space-y-4">
        <div className="eyebrow">Attività</div>
        <div><Label>Nome attività</Label><Input value={s.business_name || ""} onChange={(e) => set("business_name", e.target.value)} data-testid="s-name" /></div>
        <div><Label>Messaggio al cliente</Label><Textarea value={s.service_message || ""} onChange={(e) => set("service_message", e.target.value)} data-testid="s-message" /></div>
      </section>

      <section className="card-elevated p-5 mt-4 space-y-4">
        <div className="eyebrow">Stato servizio</div>
        <div className="flex items-center justify-between"><Label>Servizio aperto</Label><Switch checked={!!s.service_open} onCheckedChange={(v) => set("service_open", v)} data-testid="s-service-open" /></div>
        <div className="flex items-center justify-between"><Label>Bar aperto</Label><Switch checked={!!s.bar_open} onCheckedChange={(v) => set("bar_open", v)} data-testid="s-bar-open" /></div>
        <div className="flex items-center justify-between"><Label>Cucina aperta</Label><Switch checked={!!s.kitchen_open} onCheckedChange={(v) => set("kitchen_open", v)} data-testid="s-kitchen-open" /></div>
      </section>

      <section className="card-elevated p-5 mt-4 space-y-4">
        <div className="eyebrow">Tempi stimati</div>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Bar (min)</Label><Input type="number" value={s.estimated_minutes_bar || 0} onChange={(e) => set("estimated_minutes_bar", parseInt(e.target.value) || 0)} data-testid="s-eta-bar" /></div>
          <div><Label>Cucina (min)</Label><Input type="number" value={s.estimated_minutes_kitchen || 0} onChange={(e) => set("estimated_minutes_kitchen", parseInt(e.target.value) || 0)} data-testid="s-eta-kitchen" /></div>
        </div>
        <div><Label>Costo servizio (centesimi)</Label><Input type="number" value={s.service_charge_cents || 0} onChange={(e) => set("service_charge_cents", parseInt(e.target.value) || 0)} data-testid="s-service-charge" /></div>
        <div>
          <Label>Coperto per persona (centesimi)</Label>
          <Input type="number" value={s.coperto_cents || 0} onChange={(e) => set("coperto_cents", parseInt(e.target.value) || 0)} data-testid="s-coperto" />
          <div className="text-xs text-ink-500 mt-1">Applicato per persona quando l'ordine contiene almeno una categoria contrassegnata "richiede coperto".</div>
        </div>
      </section>

      <section className="card-elevated p-5 mt-4 space-y-4">
        <div className="eyebrow">Pagamenti</div>
        <div className="flex items-center justify-between"><Label>Addebita al conto postazione</Label><Switch checked={!!s.station_tab_enabled} onCheckedChange={(v) => set("station_tab_enabled", v)} data-testid="s-tab" /></div>
        <div className="flex items-center justify-between"><Label>Pagamento alla cassa</Label><Switch checked={!!s.at_cashier_enabled} onCheckedChange={(v) => set("at_cashier_enabled", v)} data-testid="s-cashier" /></div>
      </section>

      <Button onClick={save} className="mt-6 rounded-full" data-testid="save-settings">Salva impostazioni</Button>
    </div>
  );
}
